import { Button, Col, Form, Input, Modal, Row, Select, Switch, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  addSingleLeavePolicy,
  addSingleLeaveType,
  getDefaultValidity,
  loadAllLeavePolicy,
  loadAllLeaveType,
} from "../../redux/rtk/features/leavePolicy/leavePolicySlice";

const { Option } = Select;

const AddLeavePolicy = () => {
  const { list, loading } = useSelector((state) => state.leavePolicy);
  const [loader, setLoader] = useState(false);
  const [leaveTypes, setLeaveTypes] = useState([]);
  const [form] = Form.useForm();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [newLeaveType, setNewLeaveType] = useState("");
  const [creditType, setCreditType] = useState('');
  const [isCarryForwardEnabled, setIsCarryForwardEnabled] = useState(false);
  const defaultValidity = useSelector((state)=> state?.leavePolicy?.defaultValidity);
  console.log("defaultValidity", defaultValidity);
  

  const dispatch = useDispatch();
  const handleCarryForwardChange = (checked) => {
    setIsCarryForwardEnabled(checked);
  };


 useEffect(() => {
  dispatch(loadAllLeavePolicy());
  loadLeaveTypes();
  dispatch(getDefaultValidity());
}, [dispatch]);

useEffect(() => {
  if (defaultValidity?.length === 0) {
    toast.warning("Please set default validity before adding leave types.");
  }
}, [defaultValidity]);


  const loadLeaveTypes = async () => {
    const response = await dispatch(loadAllLeaveType());
    if (response.payload) {
      setLeaveTypes(response.payload);
    }
  };
  const { Title } = Typography;

  const onFinish = async (values) => {
    console.log("Form Values:", values);
    
    // Validate that defaultValidity exists and has validity_id
    if (!defaultValidity || defaultValidity.length === 0 || !defaultValidity[0]?.validity_id) {
      toast.error("Please set default validity before creating leave policies.");
      return;
    }

    // Check if the selected leave type already exists for this validity period
    const existingLeavePolicy = list?.find(
      (policy) => 
        policy.leaveTypeId === values.leaveTypeId &&
        policy.validFrom === defaultValidity[0]?.validity?.validFrom &&
        policy.validTo === defaultValidity[0]?.validity?.validTo
    );

    if (existingLeavePolicy) {
      toast.error("A leave policy with this leave type already exists for the selected validity period.");
      return;
    }

    const FormData = {
      ...values,
      validity_id: defaultValidity[0].validity_id, // Send validity_id from defaultValidity
      limit: values.limit || false,
    };
    setLoader(true);
    const resp = await dispatch(addSingleLeavePolicy(FormData));

    if (resp.payload.message === "success") {
      form.resetFields();
      setLoader(false);
      dispatch(loadAllLeavePolicy());
    } else {
      setLoader(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    toast.warning("Failed at adding department");
    setLoader(false);
  };
  const handleCreditChange = (e) => {
    setCreditType(e.target.value);
  };

  const handleAddLeaveType = async () => {
    if (newLeaveType) {
      setLoader(true);
      const resp = await dispatch(addSingleLeaveType({ leaveType: newLeaveType, defaultValidity: defaultValidity[0].validity_id }));
      if (resp.payload.message === "success") {
        // Reload leave types after adding
        await loadLeaveTypes();
        setLoader(false);
        setNewLeaveType("");
        setIsModalVisible(false);
      } else {
        setLoader(false);
      }
    } else {
      toast.warning("Please enter a leave type!");
    }
  };


  return (
    <>
      <Modal
        title="Add Leave Type"
        visible={isModalVisible}
        onOk={handleAddLeaveType}
        onCancel={() => setIsModalVisible(false)}
        confirmLoading={loader}
      >
        <Input
          placeholder="Enter leave type"
          value={newLeaveType}
          onChange={(e) => setNewLeaveType(e.target.value)}
        />
      </Modal>
      <Form
        layout="vertical"
        onFinish={onFinish}
      >

        <Row gutter={1} style={{ marginBottom: 16 }}>

          <Col flex="auto">
            <Form.Item
              name="leaveTypeId"
              label="Leave Type"
              rules={[{ required: true, message: 'Please select a leave type!' }]}
              style={{ marginBottom: 0 }}
            >
              <Select placeholder="Select leave type" loading={loading}>
                {leaveTypes.map((type) => (
                  <Option key={type.id} value={type.id}>
                    {type.leaveType}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col flex="auto" >
            <Button
  onClick={() => {
    if (defaultValidity?.length === 0) {
      toast.warning("Please set default validity before adding leave types.");
    } else {
      setIsModalVisible(true);
    }
  }}
  disabled={defaultValidity?.length === 0}
  style={{
    backgroundColor: '#4caf50',
    borderColor: '#4caf50',
    borderRadius: '8px',
    fontWeight: 'bold',
    marginTop: '30px',
  }}
>
  + Leave Type
</Button>

          </Col>
        </Row>
        <Form.Item
          name="name"
          label="leave Policy Name"
          rules={[{ required: true, message: 'Please enter the leave Policy Name!' }]}
        >
          <Input placeholder="Enter leave Policy Name" />
        </Form.Item>
        

            <Row gutter={16}>
              <Col span={8}>
              <Form.Item name="limit" label="Limit" valuePropName="checked">
              <Switch />
            </Form.Item>
            </Col>
          <Col span={8}>
            <Form.Item name="paid" label="Is Paid Leave" valuePropName="checked">
              <Switch />
            </Form.Item>
          </Col>
          </Row>
        <Form.Item>
          <Button type="primary" htmlType="submit">
            Save Policy
          </Button>
        </Form.Item>
      </Form>
    </>
  );
};

export default AddLeavePolicy;